import React from 'react';

import { Row } from 'react-bootstrap';
import { connectHits } from 'react-instantsearch-dom';

import TripSearchResult from './TripSearchResult';
import { TripSearchIndex } from '@website/types/TripSearchIndex';


interface Props {
  hits: TripSearchIndex[];
}

export function TripsSearchResultsContent({ hits }: Props) {
  return (
    <>
      {hits.length > 0 ? (
        <Row className="ps-1 pr-1">
          {hits.map((hit) => (
            <TripSearchResult key={hit.objectID} hit={hit} />
          ))}
        </Row>
      ) : (
        <p>No Trips Found</p>
      )}
    </>
  );
}

const TripSearchResults = connectHits(TripsSearchResultsContent);
export default TripSearchResults;
